<app-shop-content-block [contentId]="introRef"></app-shop-content-block>
<app-static-content-list [filter]="filter"></app-static-content-list>